import { BuilderComponent } from "@builder.io/react";
import { useRouter } from "next/router";

import { analytics } from "@flare/analytics";

import { pagesModel } from "@/builder/model-names";
import { trackExperimentEvent } from "@/builder/utilities";
import type { Page } from "@/builder/utils";
import { SEO } from "@/components/SEO";
import { BiEventsNames as biEventsNames } from "@/services/analytics/bi-event-names";

import "@/components/Builder/index";

type BiEventsNames = typeof biEventsNames;

type SendBiEventProps = {
  eventName: keyof BiEventsNames;
  properties: { [key: string]: string };
};

export interface StaticPageProps {
  page: Page;
}

export function StaticPage({ page }: StaticPageProps) {
  const { query } = useRouter();

  const seo = {
    noIndex: page.data?.noIndex,
    title: page.data?.title,
    description: page.data?.description,
    schemaMarkup: page.data?.schemaMarkup,
    openGraphImage: page.data?.openGraphImage,
  };

  return (
    <>
      <SEO {...seo} />
      <BuilderComponent
        model={pagesModel.page}
        content={page}
        data={{ queryParams: query }}
        contentLoaded={(_, content) => {
          trackExperimentEvent(content);
        }}
        context={{
          sendBiEvent: ({ eventName, properties }: SendBiEventProps) => {
            if (biEventsNames[eventName]) {
              analytics.track(biEventsNames[eventName], { ...properties });
            }
          },
        }}
      />
    </>
  );
}
